import { z } from 'zod';
import { DIAS_SEMANA } from '../enums.js';
import { HORARIO_REGEX } from '../constants.js';
export const HorarioBlocoSchema = z
    .object({
    entrada: z.string().regex(HORARIO_REGEX, 'formato HH:MM'),
    saida: z.string().regex(HORARIO_REGEX, 'formato HH:MM'),
})
    .superRefine((bloco, ctx) => {
    if (bloco.entrada >= bloco.saida) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['saida'],
            message: 'saida deve ser maior que entrada',
        });
    }
});
// Estrutura por dia da semana → array de blocos (suporta turnos partidos).
export const EscalaSchema = z.object(Object.fromEntries(DIAS_SEMANA.map((d) => [d, z.array(HorarioBlocoSchema).default([])])));
export const CreateEscalaSchema = z.object({
    nome: z.string().min(2).max(120),
    empresaId: z.string().min(1),
    secretariaId: z.string().min(1).optional(),
    funcionarioId: z.string().min(1).optional(),
    vigenciaInicio: z.string().datetime({ offset: true }),
    vigenciaFim: z.string().datetime({ offset: true }).optional(),
    escala: EscalaSchema,
});
//# sourceMappingURL=escala.js.map